import { useTracking } from 'react-tracking';

import {
  Grid,
  Text,
  useTheme,
  usePreventWindowScroll,
} from '@simplywallst/ui-core';

import ActionSheet, {
  Header,
  Panel,
  Sheet,
  Background,
} from '@/components/ActionSheet';

import NoteReminder from '../NoteReminder';

export interface NoteReminderModalProps {
  companyId: string;
  isOpen: boolean;
  noteId: string;
  onClose: () => void;
}

const NoteReminderModal = ({
  companyId,
  isOpen,
  noteId,
  onClose,
}: NoteReminderModalProps) => {
  const theme = useTheme();
  usePreventWindowScroll();

  const { Track: NoteReminderTrack, trackEvent: noteReminderTrackEvent } =
    useTracking({
      type: 'track',
      subject: 'reminder',
    });

  const handleOnClose = () => {
    noteReminderTrackEvent({
      action: 'created',
      modifier: 'dismiss',
      noteId,
    });

    onClose();
  };

  return (
    <NoteReminderTrack>
      <ActionSheet open={isOpen} onClose={handleOnClose}>
        <Background onClick={handleOnClose} />
        <Sheet>
          <Grid templateRows={`calc(40px + ${theme.safeAreaInsetTop}) auto`}>
            <Panel templateRows="max-content 1fr" row="2">
              <Header>
                <Text typography="base" color="mediumGray">
                  Add reminder
                </Text>
              </Header>
              <NoteReminder
                companyId={companyId}
                noteId={noteId}
                goBack={onClose}
              />
            </Panel>
          </Grid>
        </Sheet>
      </ActionSheet>
    </NoteReminderTrack>
  );
};

export default NoteReminderModal;
